export const createSeriesDataForName = (
  data: any,
  name: string,
  valueName: string
) => {
  //@ts-ignore
  const filteredData = Object.values(data)[0].filter(
    (item: any) => item.name === name
  )

  const seriesData = filteredData.map((item: any) => {
    const year = parseInt(item.dt.substring(0, 4), 10) // '20190101'에서 연도 부분을 추출하여 숫자로 변환
    const month = parseInt(item.dt.substring(4, 6), 10) - 1 // 월은 0부터 시작하므로 1을 빼줌
    const day = parseInt(item.dt.substring(6, 8), 10) // 일
    const hour = parseInt(item.hr, 10) // 시간
    const date = new Date(year, month, day, hour)
    return [date, item[valueName]] // eCharts에서 사용하기 위해 date를 타임스탬프로 변환
  })

  return seriesData
}

export function convertToDataItems(data: any[]): DataItem[] {
  return data.map((item) => ({
    date: new Date(item[0]),
    value: item[1], // valueName에 따라 달라지는 로직을 적용할 수 있습니다.
  }))
}

export interface DataItem {
  date: Date // 날짜
  value: number // 해당 날짜의 측정값
}

// 각 시리즈 객체에 대한 인터페이스 정의
export interface Series {
  name: string
  type: string
  data: number[][]
}

export function groupDataByMonth(data: DataItem[]): Record<number, DataItem[]> {
  const monthlyData: Record<number, DataItem[]> = {}

  data.forEach((item) => {
    // 'date' 필드가 문자열일 경우 Date 객체로 변환
    const date = new Date(item.date)
    // 옵셔널 체이닝을 사용하여 date가 undefined인 경우를 안전하게 처리
    const month = date?.getMonth() // 월 추출 (0-11)

    if (month !== undefined) {
      if (!monthlyData[month]) {
        monthlyData[month] = []
      }
      monthlyData[month].push(item)
    }
  })

  return monthlyData
}

// 일별 평균 계산
export function calculateDailyAverages(data: DataItem[]): number[][] {
  const dailyData: Record<number, number[]> = {}

  data.forEach((item) => {
    const date = new Date(item.date)
    if (isNaN(date.getTime())) {
      // 날짜가 유효한지 확인
      console.error('Invalid date:', item.date)
      return
    }

    const day = date.getDate()
    if (typeof item.value !== 'number' || isNaN(item.value)) {
      // 값이 숫자인지 확인
      console.error('Invalid value:', item.value)
      return
    }

    if (!dailyData[day]) {
      dailyData[day] = []
    }
    dailyData[day].push(item.value)
  })

  // 일별 평균 계산, NaN 체크 추가
  const dailyAverages: number[][] = Object.keys(dailyData).map((day) => {
    const values = dailyData[parseInt(day)]
    const sum = values.reduce((acc, cur) => {
      if (typeof cur !== 'number' || isNaN(cur)) {
        console.error('Invalid number in sum:', cur)
        return acc
      }
      return acc + cur
    }, 0)
    const avg = values.length > 0 ? sum / values.length : NaN
    return [parseInt(day), Number(avg.toFixed(2))]
  })

  return dailyAverages
}

export function prepareSeriesDataForECharts(data: DataItem[]): Series[] {
  const monthlyData = groupDataByMonth(data)
  const series: Series[] = []

  Object.keys(monthlyData).forEach((month) => {
    const dailyAverages = calculateDailyAverages(monthlyData[parseInt(month)])
    series.push({
      name: `${parseInt(month) + 1}월`, // 월을 1-12 범위로 조정
      type: 'line',
      data: dailyAverages,
    })
  })

  return series
}
